const initialState = {
    isStageVisible: true,
};

const stageVisibilityReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'TOGGLE_STAGE_VISIBILITY':
            return {
                ...state,
                isStageVisible: !state.isStageVisible,
            };
        default:
            return state;
    }
};

export {
    stageVisibilityReducer as default,
    initialState as stageVisibilityInitialState
};